import React from 'react';
import { Bar } from 'react-chartjs-2';
import {
  Chart as ChartJS,
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
} from 'chart.js';
import { GROWTH_AREA_COLORS } from '../utils/constants';

// Register ChartJS components
ChartJS.register(
  CategoryScale,
  LinearScale,
  BarElement,
  Title,
  Tooltip,
  Legend
);

// Helper to shorten growth area names
const getShortLabel = (label) => {
  return label
    .replace(/ Development$/, '')
    .replace(/ Personal Growth$/, '')
    .replace(/Holistic Personal Growth/, 'Holistic')
    .trim();
};

const GrowthAreaChart = ({ messages }) => {
  // Add console.log to debug incoming data
  console.log('Messages received in chart:', messages);

  // Count verses per growth area
  const growthAreaCounts = messages.reduce((acc, message) => {
    if (message.growthArea) {
      console.log('Processing message:', message.growthArea); // Debug which areas are being counted
      acc[message.growthArea] = (acc[message.growthArea] || 0) + 1;
    }
    return acc;
  }, {});

  // Log the final counts
  console.log('Growth area counts:', growthAreaCounts);

  // Prepare data for chart
  const labels = Object.keys(growthAreaCounts).map(getShortLabel);
  const data = {
    labels,
    datasets: [
      {
        label: '',
        data: Object.values(growthAreaCounts),
        backgroundColor: Object.keys(growthAreaCounts).map(area => GROWTH_AREA_COLORS[area]?.bg || 'rgba(200,200,200,0.5)'),
        borderColor: Object.keys(growthAreaCounts).map(area => GROWTH_AREA_COLORS[area]?.border || 'rgba(200,200,200,1)'),
        borderWidth: 1,
      },
    ],
  };

  const options = {
    indexAxis: 'y', // Horizontal bar chart
    responsive: true,
    plugins: {
      legend: {
        display: false,
      },
      title: {
        display: true,
        text: 'Verses by Growth Area',
        font: {
          size: 14
        },
        padding: {
          top: 10,
          bottom: 10
        }
      },
    },
    scales: {
      x: {
        beginAtZero: true,
        ticks: {
          stepSize: 1,
          font: {
            size: 11
          }
        }
      },
      y: {
        ticks: {
          font: {
            size: 10
          }
        }
      }
    },
    maintainAspectRatio: false,
    layout: {
      padding: {
        left: 5,
        right: 5,
        top: 0,
        bottom: 0
      }
    }
  };

  return (
    <div className="h-[280px] w-full md:h-[400px]">
      <Bar data={data} options={options} />
    </div>
  );
};

export default GrowthAreaChart;
